import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import Maybe from 'react-maybe';
import { MenuItem, MenuItemTypes } from '@ers/data';
import { useSimpleLayout } from '@ers/hooks';
import { Only } from '@ers/ui';

import { User, Logo, MenuTrigger } from '.';


export default function TopBar() {
    const simpleLayout = useSimpleLayout();
    const homeUrl = MenuItem.get(MenuItemTypes.Home).url();

    return (
        <header
            className={cx('topbar', {
                'topbar--simple-layout': simpleLayout
            })}
        >
            <Maybe
                of={simpleLayout}
                either={null}
                orElse={(
                    <>
                        <Only.Phone>
                            <MenuTrigger />
                        </Only.Phone>
                        <Only.TabletPortrait>
                            <MenuTrigger />
                        </Only.TabletPortrait>
                    </>
                )}
            />
            <Link to={homeUrl}>
                <Logo />
            </Link>
            <Maybe
                of={simpleLayout}
                either={null}
                orElse={(
                    <div className="topbar__section">
                        {/* <AddApplicationSmokeTest requireMobileView className="with-margin--right-5" /> */}
                        <User />
                    </div>
                )}
            />
        </header>
    );
}
